import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "antd";
import styles from "./specialSection.scss";
import SpecialAttributeCard from "./SpecialAttributeCard";
import SharingOptionsButton from "../SharingOptionsButton/SharingOptionsButton";
import FavoriteButton from "../../../FavoriteButton";
import { Favorite } from "../../../../components/Favorite";
import { HideAdButton } from "../../../../components/HideAdButton";
import CarverticalWidget from "../../../../components/CarverticalWidget";
import {
  specialAttributesInterface,
  summaryInterface
} from "../../../../typings/interfaces";
import { selectLoadedUser } from "../../../../routes/Auth/auth.ducks";
import { checkEmptyObject } from "../../../../services";

interface SpecialSectionMobileProps {
  specialAttributes?: specialAttributesInterface[];
  ad?: { id: string; module: string };
  adSummary?: summaryInterface;
  category?: string;
  details?: any;
  disabled?: boolean | undefined;
  user?: any;
}

const SpecialSectionMobile = ({
  specialAttributes,
  ad,
  adSummary,
  category,
  details,
  disabled,
  user
}: SpecialSectionMobileProps) => {
  const isOwnAd = user && checkEmptyObject(user) && adSummary && user.userId === adSummary.creatorId;

  return (
  <section>
    {specialAttributes.length !== 0 ? (
      <div className={styles.topSpecialCardWrapper}>
        <div className={styles.topSpecialCard}>Karakteristike</div>
        <Row className={styles.specialAtributesCard} gutter={11}>
          {specialAttributes.map((attribute: any) => (
            <Col key={attribute.field} span={24}>
              <SpecialAttributeCard attribute={attribute} />
            </Col>
          ))}
        </Row>
      </div>
    ) : null}
    <CarverticalWidget
      module={ad && ad.module}
      category={category}
      details={details}
    />
    <div className={`${styles.buttonCard} ${isOwnAd ? styles.twoButtons : ''}`}>
      <FavoriteButton
        disabled={disabled}
        category={category}
        flag="SpecialSection"
        component={Favorite}
        ad={adSummary}
        adLists={{ detail: { data: [adSummary] } }}
      />
      {!isOwnAd && (
        <HideAdButton
          adSummary={adSummary}
        />
      )}
      <SharingOptionsButton disabled={disabled} category={category} />
    </div>
  </section>
  );
};

export default connect(
  (state: any) => ({
    user: selectLoadedUser(state)
  }),
  null
)(SpecialSectionMobile);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SpecialSectionMobile/index.tsx